import React from 'react';
import LabelPrintingSystem from './components/LabelPrintingSystem';

function App() {
  return (
    <div className="App">
      <LabelPrintingSystem />
    </div>
  );
}

export default App;
